(function () {
  var root = document.querySelector(".__pf.__pf_rLfpVVsj");
  if (!root) return;

  var reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  function initTicker() {
    if (document.querySelector(".ss-trust-ticker")) return;

    var insertAfter = root.querySelector("section.pf-18_") || root.querySelector("section.pf-9_");
    if (!insertAfter) return;

    var items = [
      '<span class="ss-gold">★ 4.83</span> Customer Rating',
      "Free Shipping on All Orders",
      "60-Day Money-Back Guarantee",
      "Made in the USA",
      "GMP Certified",
      "Science-Backed Formulas",
    ];

    var row = "";
    items.forEach(function (text) {
      row +=
        '<span class="ss-trust-ticker__item">' +
        text +
        '</span><span class="ss-trust-ticker__sep" aria-hidden="true">◆</span>';
    });

    var ticker = document.createElement("div");
    ticker.className = "ss-trust-ticker";
    ticker.setAttribute("role", "region");
    ticker.setAttribute("aria-label", "Store trust highlights");

    var track = document.createElement("div");
    track.className = "ss-trust-ticker__track";
    track.innerHTML = row + row;
    ticker.appendChild(track);

    insertAfter.insertAdjacentElement("afterend", ticker);
  }

  function addReveal(el, delayIndex) {
    el.classList.add("ss-reveal", "ss-reveal-delay-" + ((delayIndex % 4) + 1));
  }

  function initReveal() {
    var benefitSections = [root.querySelector("section.pf-27_"), root.querySelector("section.pf-30_")].filter(
      Boolean
    );
    var whySection = root.querySelector("section.pf-62_");
    var delay = 0;

    benefitSections.forEach(function (section) {
      section.querySelectorAll("h3.pf-heading-1-h3, img[data-pf-type='Image5']").forEach(function (el) {
        addReveal(el, delay++);
      });
    });

    if (whySection) {
      var heading = whySection.querySelector("h3");
      if (heading) addReveal(heading, delay++);

      whySection.querySelectorAll("[data-pf-type='FlexBlock']").forEach(function (block) {
        if (block.querySelector("img[data-pf-type='Image5']")) {
          block.classList.add("ss-icon-block");
          addReveal(block, delay++);
        }
      });
    }

    var revealEls = root.querySelectorAll(".ss-reveal");
    if (!revealEls.length) return;

    if (reducedMotion) {
      revealEls.forEach(function (el) {
        el.classList.add("ss-visible");
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add("ss-visible");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: "0px 0px -32px 0px" }
    );

    revealEls.forEach(function (el) {
      observer.observe(el);
    });
  }

  function initProductCards() {
    var productSection = root.querySelector("section.pf-45_");
    if (!productSection) return;

    productSection.querySelectorAll("[data-pf-type='ProductBox']").forEach(function (box) {
      box.classList.add("ss-product-card");
    });
  }

  function init() {
    initTicker();
    initReveal();
    initProductCards();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
